import {
  DEALERS_PARAM_FETCH_FIELD_VALUE,
  DEALERS_PARAMS_FIELDS,
  DIAGNOSTIC_CARD_VALUE_FIELDS,
  PTS_VALUE_FIELDS,
  STEERING_WHEEL_VALUES,
  STORE_FIELDS,
  VALUE_FIELDS,
} from './constants';

const CAR_INSTANCE_STATE = Object.values(VALUE_FIELDS).reduce(
  (acc, key) => {
    acc[key] ??= '';

    return acc;
  },
  {
    [VALUE_FIELDS.DEFAULT_PRICE]: 0,
    [VALUE_FIELDS.DIAGNOSTIC_CARD]: {
      [DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]: '',
      [DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]: '',
      [DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]: '',
    },
    [VALUE_FIELDS.ENGINE_POWER]: 0,
    [VALUE_FIELDS.ENGINE_VOLUME]: 500,
    [VALUE_FIELDS.ID]: 0,
    [VALUE_FIELDS.IS_NEW]: true,
    [VALUE_FIELDS.MILEAGE]: 0,
    [VALUE_FIELDS.OFFER_PRICE]: 0,
    [VALUE_FIELDS.PRICE]: 0,
    [VALUE_FIELDS.PTS]: {
      [PTS_VALUE_FIELDS.ISSUE_DATE]: '',
      [PTS_VALUE_FIELDS.NUMBER]: '',
      [PTS_VALUE_FIELDS.SERIES]: '',
    },
    [VALUE_FIELDS.STEERING_WHEEL]: STEERING_WHEEL_VALUES.LEFT,
    [VALUE_FIELDS.YEAR]: 0,
  }
);

const DEALERS_PARAMS_STATE = {
  [DEALERS_PARAMS_FIELDS.DEALER_ID]: null,
  [DEALERS_PARAMS_FIELDS.FETCH_DEALERS_PARAMS]: DEALERS_PARAM_FETCH_FIELD_VALUE.WAIT,
  [DEALERS_PARAMS_FIELDS.NEW_CARS]: false,
  [DEALERS_PARAMS_FIELDS.USED_CARS]: false,
};

export const ERRORS_STATE = Object.values(VALUE_FIELDS).reduce(
  (acc, key) => {
    acc[key] ??= '';

    return acc;
  },
  {
    [VALUE_FIELDS.DIAGNOSTIC_CARD]: {
      [DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]: '',
      [DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]: '',
      [DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]: '',
    },
    [VALUE_FIELDS.PTS]: {
      [PTS_VALUE_FIELDS.ISSUE_DATE]: '',
      [PTS_VALUE_FIELDS.NUMBER]: '',
      [PTS_VALUE_FIELDS.SERIES]: '',
    },
  }
);

export const INITIAL_STATE = {
  [STORE_FIELDS.CAR_INFO_FETCH]: false,
  [STORE_FIELDS.CAR_INSTANCE]: CAR_INSTANCE_STATE,
  [STORE_FIELDS.DEALERS_PARAMS]: DEALERS_PARAMS_STATE,
  [STORE_FIELDS.DECLINE_DROP_ERRORS]: false,
  [STORE_FIELDS.DISABLE_FIELDS]: [],
  [STORE_FIELDS.ERROR]: '',
  [STORE_FIELDS.ERRORS]: ERRORS_STATE,
  [STORE_FIELDS.FETCH]: true,
  [STORE_FIELDS.HIDDEN_FIELDS]: [],
  [STORE_FIELDS.IS_COLLAPSABLE]: true,
  [STORE_FIELDS.IS_DISABLE]: false,
  [STORE_FIELDS.IS_OPEN_BLOCK]: false,
  [STORE_FIELDS.IS_OPEN_DETAILS]: false,
  [STORE_FIELDS.IS_PATCHING]: false,
  [STORE_FIELDS.PATCH_IS_NEW]: false,
  [STORE_FIELDS.REQUIRED_FIELDS]: [],
  [STORE_FIELDS.SCROLL_TO]: null,
};

/** @deprecated Нужно использовать "ERRORS_STATE" */
export const errors = ERRORS_STATE;

export default INITIAL_STATE;
